import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { EditAccommodationBlockForm } from "Bands/containers/EditAccommodationBlockForm/EditAccommodationBlockForm";
import { dataMetaSelector, eventBlockSelectorCreator } from "Bands/state";
import { BAND_ACTIONS, EventBlocks, IAccommodationBlock } from "Bands/types";
import { FC } from "react";
import { copy } from "shared/assets";
import { Hotel } from "shared/assets/icons";
import { Card, Loader } from "shared/components";
import { Spacer } from "shared/layout";
import { FourOhFour, FourOhThree } from "shared/pages";
import { IAPIState } from "shared/types";
import { mapUserPermissions } from "shared/utils";

const blockCopy = copy.accommodationBlock;

export const EditAccommodationBlockPage: FC = () => {
  const { blockId } = useParams<{ blockId: string }>();

  const blockSelector = eventBlockSelectorCreator(blockId, EventBlocks.accommodation);
  const block = useSelector(blockSelector) as IAccommodationBlock;

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.getEventAccommodationBlock));

  const renderContent = () => {
    if (!block) return <Loader />; // fetching

    return (
      <Spacer size="xl">
        <EditAccommodationBlockForm block={block} />
      </Spacer>
    );
  };

  if (apiMeta?.status !== IAPIState.pending && !block) return <FourOhFour />;

  if (block && !mapUserPermissions(block.permissions || []).EDIT) {
    return <FourOhThree />;
  }

  return (
    <Card title={blockCopy.edit.title.replace("%title", block?.title || "...")} icon={Hotel}>
      {renderContent()}
    </Card>
  );
};
